import React from 'react';

import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useQuery, useMutation } from '@tanstack/react-query';

import FormContainer from '../../../FormContainer';

import useDocumentForm from '../../../../../forms/loan/document';
import DocumentService from '../../../../../services/DocumentService';
import { useUiContext } from '../../../../../context/UiContext';

export default function Document({ lenderId }) {
  const { showToast } = useUiContext();

  const { id, documentId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const isLender = location.pathname.includes('lenders');

  const { data: document } = useQuery({
    queryKey: ['document', documentId],
    queryFn: () => DocumentService.getDocument(documentId),
  });

  const { mutate: updateDocument } = useMutation({
    mutationFn: async (formValues) => {
      await DocumentService.updateDocument({
        documentId: document.id,
        formValues: {
          ...document,
          description: formValues.description,
          date: formValues.date,
          private_document: {
            ...document.private_document,
            type: formValues.type,
            name: formValues.name,
          },
        },
      });
    },
    onSuccess: () => {
      showToast({
        text: 'Document updated successfully',
        type: 'success',
      });
      // User is lender
      if (isLender) {
        navigate(`/lenders/${id}?tab=Documents`);
        // User is admin and editing a lender
      } else if (lenderId) {
        navigate(`/lenders/${lenderId}?tab=Documents`);
        // User is admin and editing a loan
      } else {
        navigate(`/loans/${id}?tab=Documents`);
      }
    },
    onError: (error) => {
      console.log(error);
      showToast({
        text: error?.response?.data?.message || 'Something went wrong',
        type: 'error',
      });
    },
  });

  const documentForm = useDocumentForm(updateDocument, {
    description: document?.description,
    name: document?.private_document.name,
    type: document?.private_document.type,
    date: document?.date,
  });

  return (
    <div className="p-7 col-span-full sm:col-span-6 xl:col-span-4 bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-slate-200 dark:border-slate-700 mb-10">
      <FormContainer
        form={documentForm}
        isVisible
        gridStyle="grid gap-5 md:grid-cols-3 xl:grid-cols-3"
      />
    </div>
  );
}
